/* VIEWED EDITS — recently viewed, per device. */
(function () {
  'use strict';
  const KEY = 'zcrave.viewed.v1';
  const MAX = 12;
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
  const write = (v) => { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* private mode */ } };

  const here = document.body.dataset.productHandle;
  if (here) {
    const list = read().filter((h) => h !== here);
    list.unshift(here);
    write(list.slice(0, MAX));
  }

  const mount = document.querySelector('[data-recently-viewed]');
  if (!mount) return;
  const handles = read().filter((h) => h !== here).slice(0, Number(mount.dataset.limit) || 8);
  if (!handles.length) { mount.closest('[data-recently-viewed-section]')?.remove(); return; }

  Promise.all(handles.map(async (h) => {
    try {
      const r = await fetch(`/products/${h}?section_id=vault-card`);
      return r.ok ? await r.text() : '';
    } catch (e) { return ''; }
  })).then((cards) => {
    const html = cards.filter(Boolean).join('');
    if (html) mount.innerHTML = html;
    else mount.closest('[data-recently-viewed-section]')?.remove();
    document.dispatchEvent(new CustomEvent('zcrave:cards-added'));
  });
})();
